import { Controller } from "@hotwired/stimulus"

// Required has no coherent meaning for a boolean field — a checkbox always
// submits true/false, never blank (see GEE-111). Keeps the Required checkbox
// in sync with the Field Type select without a page reload.
export default class extends Controller {
    static targets = ["fieldType", "required", "requiredHint"]

    connect() {
        this.toggleRequired()
    }

    toggleRequired() {
        const isBoolean = this.fieldTypeTarget.value === "boolean"

        this.requiredTarget.disabled = isBoolean
        if (isBoolean) {
            this.requiredTarget.checked = false
        }

        this.requiredHintTarget.classList.toggle("d-none", !isBoolean)
    }
}